(function() {
  var script = document.createElement('script');
  script.type = 'application/ld+json';
  script.text = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Fluid and Fire",
    "image": "https://fluidandfire.com/cdn/shop/files/RAPHAELR-FF_Ico_White_Background_eb12884d-79a1-427b-887d-68e86ea2c6fe.png",
    "@id": "",
    "url": "https://fluidandfire.com/",
    "telephone": "",
    "priceRange": "$$",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "8 The Green",
      "addressLocality": "Dover",
      "addressRegion": "DE",
      "postalCode": "19901",
      "addressCountry": "US"
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      "opens": "00:00",
      "closes": "23:59"
    },
    "sameAs": [
      "https://www.facebook.com/fluidandfireusa",
      "https://www.instagram.com/fluidandfireusa",
      "https://www.youtube.com/@fluidandfire",
      "https://www.pinterest.com/fluidandfire/"
    ]
  });
  document.head.appendChild(script);
})();